export enum RegisterDaycareFields {
  Answer = 'answer',
  Donors = 'donors',
  Note = 'note',
}
